// @flow strict

import * as React from 'react'
import { SectionThemes, SectionWrapper } from '../../../SectionWrapper'
import MoreInformationForm from './MoreInformationForm'
import { type FormResult } from './formTypes'

import styles from './MoreInformationSection.module.scss'

type Props = {
  title: string,
  description: string,
  businessIndustries: Array<string>,
}

function MoreInformationSection({
  title,
  description,
  businessIndustries,
}: Props) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false)
  const [formResult, setResult] = React.useState<?FormResult>({
    success: false,
    message: '',
  })

  return (
    <>
      <SectionWrapper
        theme={SectionThemes.LIGHT}
        contentClassName={styles.baseContent}
      >
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.description}>{description}</p>

        {formResult && formResult.message !== '' ? (
          <div className={styles.notice}>
            <p>{formResult.message}</p>
          </div>
        ) : (
          <MoreInformationForm
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            setResult={setResult}
            businessIndustries={businessIndustries}
          />
        )}
      </SectionWrapper>
    </>
  )
}

export default MoreInformationSection
